import { customAxios } from "@/utils/customAxios/customAxios"
import { getToken } from "@/utils/functions/getToken"
import {
  BookingOptionsCancellationFeeUpdateBeautyInput,
  BookingOptionsCancellationFeeUpdateBeautyOutput,
  BookingOptionsCancellationNoticeDaysUpdateBeautyInput,
  BookingOptionsCancellationNoticeDaysUpdateBeautyOutput,
  BookingOptionsPercentagePrepaymentUpdateBeautyInput,
  BookingOptionsPercentagePrepaymentUpdateBeautyOutput,
  BookingOptionsCanReserveWithoutPaymentUpdateBeautyInput,
  BookingOptionsCanReserveWithoutPaymentUpdateBeautyOutput,
} from "@okeys/shared-utils"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { AxiosError } from "axios"

// Mutation pour cancellationFee
export const useCancellationFeeMutation = () => {
  const queryClient = useQueryClient()

  const cancellationFeeMutation = useMutation<
    BookingOptionsCancellationFeeUpdateBeautyOutput,
    AxiosError,
    BookingOptionsCancellationFeeUpdateBeautyInput
  >({
    mutationFn: async (data) => {
      const token = await getToken()
      const response = await customAxios.put(
        "/data-shop/reservation-options/cancellation-fee",
        data,
        {
          headers: {
            Authorization: token,
          },
        }
      )
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["shopData"] })
    },
  })

  return { cancellationFeeMutation: cancellationFeeMutation.mutate }
}

// Mutation pour cancellationNoticeDays
export const useCancellationNoticeDaysMutation = () => {
  const queryClient = useQueryClient()

  const cancellationNoticeDaysMutation = useMutation<
    BookingOptionsCancellationNoticeDaysUpdateBeautyOutput,
    AxiosError,
    BookingOptionsCancellationNoticeDaysUpdateBeautyInput
  >({
    mutationFn: async (data) => {
      const token = await getToken()
      const response = await customAxios.put(
        "/data-shop/reservation-options/cancellation-notice-days",
        data,
        {
          headers: {
            Authorization: token,
          },
        }
      )
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["shopData"] })
    },
  })

  return { cancellationNoticeDaysMutation: cancellationNoticeDaysMutation.mutate }
}

// Mutation pour percentagePrepayment
export const usePercentagePrepaymentMutation = () => {
  const queryClient = useQueryClient()

  const percentagePrepaymentMutation = useMutation<
    BookingOptionsPercentagePrepaymentUpdateBeautyOutput,
    AxiosError,
    BookingOptionsPercentagePrepaymentUpdateBeautyInput
  >({
    mutationFn: async (data) => {
      const token = await getToken()
      const response = await customAxios.put(
        "/data-shop/reservation-options/percentage-prepayment",
        data,
        {
          headers: {
            Authorization: token,
          },
        }
      )
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["shopData"] })
    },
  })

  return { percentagePrepaymentMutation: percentagePrepaymentMutation.mutate }
}

// Mutation pour canReserveWithoutPayment
export const useCanReserveWithoutPaymentMutation = () => {
  const queryClient = useQueryClient()

  const canReserveWithoutPaymentMutation = useMutation<
    BookingOptionsCanReserveWithoutPaymentUpdateBeautyOutput,
    AxiosError,
    BookingOptionsCanReserveWithoutPaymentUpdateBeautyInput
  >({
    mutationFn: async (data) => {
      const token = await getToken()
      const response = await customAxios.put(
        "/data-shop/reservation-options/can-reserve-without-payment",
        data,
        {
          headers: {
            Authorization: token,
          },
        }
      )
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["shopData"] })
    },
  })

  return { canReserveWithoutPaymentMutation: canReserveWithoutPaymentMutation.mutate }
}